var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export var convertLanLngToString = function (latLng) {
    if (!latLng || (!latLng.latitude && !latLng.longitude)) {
        return '';
    }
    return "".concat(latLng.latitude || '', ", ").concat(latLng.longitude || '');
};
export var convertStringToLatLng = function (str) {
    if (!str) {
        return null;
    }
    var _a = __read(str.split(', '), 2), latitudeStr = _a[0], longitudeStr = _a[1];
    if (!latitudeStr || !longitudeStr) {
        return {
            latitude: NaN,
            longitude: NaN,
        };
    }
    var latitude = parseFloat(latitudeStr);
    var longitude = parseFloat(longitudeStr);
    return {
        latitude: latitudeStr.endsWith('.') || isNaN(latitude) ? NaN : latitude,
        longitude: longitudeStr.endsWith('.') || isNaN(longitude) ? NaN : longitude,
    };
};
